import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MessageCircle, Clock, Package, HelpCircle, Calendar } from 'lucide-react';

interface MessageTemplatesProps {
  onSelectTemplate: (template: string) => void;
  serviceTitle?: string;
  productTitle?: string;
  type: 'service' | 'product';
}

const MessageTemplates = ({ onSelectTemplate, serviceTitle, productTitle, type }: MessageTemplatesProps) => {
  const serviceTemplates = [
    {
      icon: HelpCircle,
      title: "Vraag over dienst",
      template: `Hoi! Ik ben geïnteresseerd in je "${serviceTitle}" dienst. Kun je me wat meer vertellen over wat je precies behandelt?`
    },
    {
      icon: Calendar,
      title: "Beschikbaarheid",
      template: `Hallo! Ik zou graag een afspraak willen maken voor "${serviceTitle}". Wat is je beschikbaarheid deze week?`
    },
    {
      icon: Clock,
      title: "Duur & proces",
      template: `Hoi! Ik heb een vraag over "${serviceTitle}". Hoe lang duurt de sessie en hoe verloopt het proces precies?`
    },
    {
      icon: Package,
      title: "Pakket op maat",
      template: `Hallo! Ik ben geïnteresseerd in "${serviceTitle}". Bied je ook aangepaste pakketten aan voor mijn specifieke situatie?`
    }
  ];

  const productTemplates = [
    {
      icon: HelpCircle,
      title: "Vraag over product",
      template: `Hoi! Ik ben geïnteresseerd in je "${productTitle}". Kun je me wat meer vertellen over het product?`
    },
    {
      icon: Package,
      title: "Verzending & levering",
      template: `Hallo! Ik overweeg om "${productTitle}" te kopen. Hoe verloopt de verzending en wat zijn de levertijden?`
    },
    {
      icon: Clock,
      title: "Beschikbaarheid",
      template: `Hoi! Is "${productTitle}" nog op voorraad? En wanneer is het beschikbaar voor verzending?`
    },
    {
      icon: MessageCircle,
      title: "Meer informatie",
      template: `Hallo! Ik heb een paar vragen over "${productTitle}". Zou je me wat meer details kunnen geven?`
    }
  ];

  const templates = type === 'service' ? serviceTemplates : productTemplates;

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <MessageCircle className="h-5 w-5 text-stone-600" />
          Snel een bericht sturen
        </CardTitle>
        <p className="text-sm text-gray-600">
          Kies een template om je gesprek te starten
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        {templates.map((template, index) => (
          <Button
            key={index}
            variant="outline"
            className="w-full justify-start text-left p-4 h-auto hover:bg-stone-50 border-gray-200"
            onClick={() => onSelectTemplate(template.template)}
          >
            <div className="flex items-start gap-3">
              <template.icon className="h-4 w-4 text-stone-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-900 text-sm">{template.title}</p>
                <p className="text-xs text-gray-600 mt-1 line-clamp-2">
                  {template.template}
                </p>
              </div>
            </div>
          </Button>
        ))}
        
        <Button
          variant="ghost"
          className="w-full mt-3 text-gray-600 hover:text-gray-800"
          onClick={() => onSelectTemplate('')}
        >
          Eigen bericht schrijven
        </Button>
      </CardContent>
    </Card>
  );
};

export default MessageTemplates;